module.exports = __webpack_public_path__ + "static/onboarding1.405d075f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/onboarding1.gif
// module id = 469
// module chunks = 261706647590803